import type { Meeting } from "@repo/types";
import { ExportForm } from "../common/ExportForm";
import { meetingsExportService } from "@/services/meetingsExportService";

export interface ExportMeetingFormProps {
  getMeetings: () => Meeting[];
  getPreselectedFields: () => string[];
  onCancel?: () => void;
}

export const ExportMeetingForm = ({
  getMeetings,
  getPreselectedFields,
  onCancel,
}: ExportMeetingFormProps) => {
  return (
    <ExportForm<Meeting>
      getData={getMeetings}
      getPreselectedFields={getPreselectedFields}
      onCancel={onCancel}
      downloadName="meetings.csv"
      exportService={meetingsExportService}
    />
  );
};
